<template>
    <div class="body_main">
        <div class="body_bd_main flex_c_between">
            <div class="left_body" v-if="foldOrExpandPatient">
                <div class="title_body flex_c_between">
                    <div class="flex_c_left">
                        <div class="title_line"></div>
                        <div class="title_span flex_c_left">患者管理</div>
                    </div>
                    <div class="title_body_expand icon_f flex_c_right" @click="foldOrExpandPatientList()">
                        <el-icon>
                            <Fold/>
                        </el-icon>
                    </div>
                </div>
                <div class="patient_tabs">
                    <div :class="patientActiveTab === 'today' ? 'patient_tab patient_tab_active' : 'patient_tab'"
                         @click="switchPatientTab('today')">今日预约
                    </div>
                    <div :class="patientActiveTab === 'patients' ? 'patient_tab patient_tab_active' : 'patient_tab'"
                         @click="switchPatientTab('patients')">患者列表
                    </div>
                </div>
                <div v-if="patientActiveTab === 'today'" class="reservation_panel">
                    <div class="reservation_stats">
                        <div v-for="item in reservationStats" :key="item.key"
                             :class="['reservation_stat', 'reservation_stat_' + item.color, reservationStatus === item.key ? 'reservation_stat_active' : '']"
                             @click="switchReservationStatus(item.key)">
                            <div class="reservation_stat_count">{{ item.count }}</div>
                            <div class="reservation_stat_label">{{ item.label }}</div>
                        </div>
                    </div>
                    <div class="patient_table_search">
                        <el-input v-model="reservationQuery.cardPatientName" clearable placeholder="搜索预约人姓名"
                                  @input="handleReservationSearchInput"></el-input>
                    </div>
                    <div class="patient_table_thead">
                        <div class="thead_ul flex_c_left">
                            <div class="tb_li">姓名</div>
                            <div class="tb_li_1">性别</div>
                            <div class="tb_li_2">年龄</div>
                        </div>
                    </div>
                    <div class="patient_table_body reservation_table_body" v-infinite-scroll="loadMoreReservations"
                         :infinite-scroll-immediate="false"
                         :infinite-scroll-disabled="reservationLoading || reservationLastPage"
                         v-loading="reservationLoading">
                        <div :class="isReservationSelected(item) ? 'tb_ul_act flex_c_left':'tb_ul flex_c_left'"
                             v-for="(item, index) in reservationList" :key="item.isReturn ? 'rv-' + item.returnId : (item.reId || index)"
                             @click="chooseReservationPatient(item)">
                            <div class="tb_li flex_c_left">
                                <span class="reservation_row_name">{{ reservationRowLabel(item) }}</span>
                                <el-tag :class="['reservation_status_tag', 'reservation_status_' + reservationStatusKey(item)]"
                                         size="small" effect="light">{{ reservationStatusLabel(item) }}</el-tag>
                                <!-- 回诊行的接诊/完成入口：接诊=置为已接诊并载入患者，完成=结束本次回诊 -->
                                <template v-if="item.isReturn">
                                    <el-button v-if="item.status !== 'CALLED'" link type="primary"
                                               class="reservation_row_btn" @click.stop="acceptReturnVisit(item)">接诊</el-button>
                                    <el-button v-else link type="success"
                                               class="reservation_row_btn" @click.stop="completeReturnVisitRow(item)">完成</el-button>
                                </template>
                            </div>
                            <div class="tb_li_1">{{ reservationSex(item.cardPatientSex) }}</div>
                            <div class="tb_li_2">{{ item.age }}岁</div>
                        </div>
                        <el-empty v-if="!reservationLoading && reservationList.length <= 0" image-size="56"
                                  :description="reservationEmptyText()"></el-empty>
                    </div>
                </div>
                <div v-else class="patient_list_panel">
                    <div class="patient_table_search">
                        <div class="table_search_ul flex_c_between">
                            <el-col :span="19">
                                <el-input type="text" v-model="patientQueryParams.name" placeholder="搜索关键字"
                                          @keyup.enter="searchPatientList()"></el-input>
                            </el-col>
                            <el-col class="flex_c_right" :span="5">
                                <el-button type="primary" @click="searchPatientList()">查询</el-button>
                                <!--                            <el-button type="warning" @click="resetMedical()">新患者</el-button>-->
                            </el-col>
                        </div>
                    </div>
                    <div class="patient_table_thead">
                        <div class="thead_ul flex_c_left">
                            <div class="tb_li">姓名</div>
                            <div class="tb_li_1">性别</div>
                            <div class="tb_li_2">年龄</div>
                        </div>
                    </div>
                    <div class="patient_table_body" v-infinite-scroll="loadMorePatient" style="overflow:auto"
                         :infinite-scroll-immediate="false" v-loading="patiantloading"
                         :infinite-scroll-disabled="loadDisabled">
                        <div :class="chooseDppId === item.dppId ? 'tb_ul_act flex_c_left':'tb_ul flex_c_left'"
                             v-for="(item, index) in patientList" :key="index" @click="choosePatients(item)">
                            <div class="tb_li flex_c_left">
                            <span class="mrr10"><el-avatar :src="item.avatar"
                                                           style="width: 20px;height: 20px"></el-avatar></span>
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="tb_li_1">{{ item.sex === '0' ? '男' : item.sex === '1' ? '女' : '未知' }}</div>
                            <div class="tb_li_2">{{ item.age }}岁</div>
                        </div>
                        <el-empty image-size="56" description="暂无患者信息" v-if="patientList.length <= 0">
                            <el-button type="primary" size="small" plain icon="Plus" round
                                       @click="resetMedical()">新增患者
                            </el-button>
                        </el-empty>
                    </div>
                </div>
            </div>
            <div class="left_body_expand" v-if="!foldOrExpandPatient">
                <div class="title_body_expand icon_f flex_c" @click="foldOrExpandPatientList()">
                    <el-icon>
                        <Expand/>
                    </el-icon>
                </div>
            </div>
            <div :class="foldOrExpandPatient?'right_body':'right_body_expand'" v-loading="loading">
                <el-row class="content_main_bd flex_t_between">
                    <el-col class="content_body" :span="15" v-loading="multiPrescriptionSubmitting || loading"
                            element-loading-text="正在提交处方，请稍候...">
                        <div class="title_body title_con flex_c_left">
                            <div class="title_line"></div>
                            <div class="title_span flex_c_left">患者开方</div>
                        </div>
                        <!--初诊开方页面-->
                        <div class="main_body">
                            <div class="title_alert_body" v-if="titleAlertShow">
                                <div class="title_alert flex_c_between">
                                    <el-col :span="16" class="flex_c_left font_14">
                                        系统检测到当前患者【{{ patientInfo.name }}】存在未提交的病历开方信息，您可以继续编辑患者信息！
                                    </el-col>
                                    <el-col :span="8" class="flex_c_right font_14">
                                        <div class="mrr10">
                                            <span class="font_gold cursor" @click="closeTitleAlert()">知道了</span>
                                            <span class="font_gray">({{ titleAlertCountdown }}秒后关闭)</span>
                                        </div>
                                        <div class="font_blue cursor" @click="againMedicalOrder(patientInfo.dppId)">
                                            重新开方
                                        </div>
                                    </el-col>
                                </div>
                            </div>
                            <!--患者基本信息-->
                            <div class="right_floor clinical_section clinical_section_basic">
                                <div class="title_in_body flex_c_left">
                                    <div class="title_line"></div>
                                    <div class="title_span flex_c_left">基本信息</div>
                                </div>
                                <el-form class="step_floor_con" ref="patientInfoFrom" :model="patientInfo"
                                         label-width="80px">
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="姓名" :rules="[{required: true}]">
                                                <div class="width100 posi_rela">
                                                    <el-input v-model="searchPatientName"
                                                              placeholder="姓名(必填)"
                                                              clearable
                                                              @blur="handleInputBlur"
                                                              @input="queryPatiantListByName"></el-input>
                                                    <div class="name_select_con"
                                                         v-if="nameSelectConShow && patientRange.length > 0">
                                                        <div
                                                            :class="item.isChoose ? 'name_select_li name_select_li_act flex_c_between':'name_select_li flex_c_between'"
                                                            v-for="(item, index) in patientRange" :key="index"
                                                            @click="sureChoosePatientInfo(item.dppId)">
                                                            <div class="font_w" style="float: left">{{
                                                                    item.name
                                                                }}
                                                            </div>
                                                            <div
                                                                style="float: right; color: var(--el-text-color-secondary); font-size: 13px;">
                                                                {{ item.identity }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="身份证号" :rules="[{required: true}]">
                                                <el-input v-model="patientInfo.identity"
                                                          placeholder="身份证号(必填)"
                                                          @change="changePatientIdentity()"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="联系电话" :rules="[{required: true}]">
                                                <el-input v-model="patientInfo.phoneNumber"
                                                          placeholder="联系电话(必填)"
                                                          @change="changePatientPhoneNumber()"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="性别" :rules="[{required: true}]">
                                                <el-radio-group v-model="patientInfo.sex">
                                                    <el-radio label="0">男</el-radio>
                                                    <el-radio label="1">女</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item class="mrb10" label="省/市/区">
                                                <el-cascader style="width: 100%;" :options="regionData"
                                                             v-model="patientRegion"
                                                             placeholder="请选择所在省/市/区(选填)"
                                                             @change="changePatientAddress()"></el-cascader>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="详细地址">
                                                <el-input v-model="patientAddress" @change="changePatientAddress()"
                                                          placeholder="患者常住地详细地址(选填)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="过敏史">
                                                <el-input v-model="patientInfo.allergyHistory"
                                                          placeholder="过敏史(选填)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                </el-form>
                            </div>
                            <!--诊断信息-->
                            <div class="right_floor clinical_section clinical_section_diagnosis">
                                <div class="title_in_body flex_c_left">
                                    <div class="title_line"></div>
                                    <div class="title_span flex_c_left">诊断信息</div>
                                    <el-tooltip content="展开/收起" placement="bottom" effect="dark">
                                        <el-button v-if="false" class="cursor" type="primary" size="small" round
                                                   color="#c8c8c8"
                                                   :icon="medicalOrderShow?'ArrowUpBold':'ArrowDownBold'"
                                                   @click="changePersonInfoShow()"></el-button>
                                    </el-tooltip>
                                </div>
                                <el-form class="step_floor_con" ref="patientInfoFrom"
                                         label-width="80px">
                                    <el-row class="el_row_width2" :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="主诉">
                                                <el-input type="textarea" v-model="medicalOrder.mainSuit"
                                                          placeholder="主诉"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20">
                                        <el-col :span="24">
                                            <el-form-item label="诊断" :rules="[{required: true}]">
                                                <el-input type="textarea" v-model="medicalOrder.clinicalDiagnosis"
                                                          placeholder="诊断"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width2" :gutter="20" v-if="medicalOrderShow">
                                        <el-col :span="24">
                                            <el-form-item label="既往史">
                                                <el-input type="textarea" placeholder="既往史(选填)"
                                                          v-model="medicalOrder.patientMedicalHistory"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width2" :gutter="20" v-if="medicalOrderShow">
                                        <el-col :span="24">
                                            <el-form-item label="现病史">
                                                <el-input type="textarea" placeholder="现病史(选填)"
                                                          v-model="medicalOrder.nowMedicalHistory"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width" :gutter="20" v-if="medicalOrderShow">
                                        <el-col :span="24">
                                            <el-form-item label="检查记录">
                                                <el-input type="textarea" v-model="medicalOrder.inspectionRecord"
                                                          placeholder="检查记录(选填)"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row class="el_row_width flex_c" :gutter="20">
                                        <el-tooltip content="查看更多/收起" placement="bottom" effect="dark">
                                            <el-button type="primary" size="small" round plain
                                                       @click="changeMedicalOrderShow()">
                                                <span>{{ medicalOrderShow ? '收起' : '查看更多' }}</span>
                                                <el-icon class="el-icon--right" v-if="medicalOrderShow">
                                                    <ArrowUpBold/>
                                                </el-icon>
                                                <el-icon class="el-icon--right" v-if="!medicalOrderShow">
                                                    <ArrowDownBold/>
                                                </el-icon>
                                            </el-button>
                                        </el-tooltip>
                                    </el-row>
                                </el-form>
                            </div>
                            <!--药方信息-->
                            <div class="right_floor clinical_section clinical_section_prescriptions">
                                <div class="prescription_sticky_head">
                                <div class="prescription_section_header">
                                    <div class="prescription_section_title">
                                        <div class="title_line"></div>
                                        <div class="title_span flex_c_left">
                                            药方信息
                                            <el-tag class="prescription_count_tag" size="small" type="primary">
                                                {{ prescriptionDrafts.length }} 张
                                            </el-tag>
                                        </div>
                                        <span
                                            class="prescription_section_hint">每个处方独立保存药材、用法、配送和费用</span>
                                    </div>
                                    <div class="prescription_workspace_actions">
                                        <el-button size="small" type="primary" plain icon="Plus"
                                                   :disabled="prescriptionDrafts.length >= maxPrescriptionOrders || multiPrescriptionSubmitting"
                                                   @click="addPrescriptionDraft">新增处方
                                        </el-button>
                                        <el-button size="small" type="danger" plain icon="Delete"
                                                   :disabled="prescriptionDrafts.length <= 1 || multiPrescriptionSubmitting"
                                                   @click="removePrescriptionDraft">删除处方
                                        </el-button>
                                    </div>
                                </div>
                                <div class="prescription_tabs_bar">
                                    <div class="prescription_tabs_scroll">
                                        <button v-for="(draft, draftIndex) in prescriptionDrafts" :key="draft.id"
                                                type="button"
                                                :class="['prescription_tab_item', {active: activePrescriptionIndex === draftIndex, disabled: multiPrescriptionSubmitting}]"
                                                @click="switchPrescriptionDraft(draftIndex)">
                                            <span class="prescription_tab_number">{{
                                                    String(draftIndex + 1).padStart(2, '0')
                                                }}</span>
                                            <span class="prescription_tab_content">
                                                <strong>处方 {{ draftIndex + 1 }}</strong>
                                                <small>{{ draft.billingTypeName }} · {{
                                                        draft.medicineCount
                                                    }}味药材</small>
                                            </span>
                                            <span class="prescription_tab_price">￥{{ draft.orderPrice }}</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="prescription_active_label flex_center">
                                    <span class="prescription_active_line"></span>
                                    <span>当前处方</span>
                                    <strong>处方 {{ activePrescriptionIndex + 1 }}</strong>
                                    <span class="prescription_active_line"></span>
                                </div>
                                </div>
                                <div class="prescription_tab_panel">
                                    <div class="med_body">
                                        <el-col :span="24">
                                            <div class="med_head_btns">
                                                <el-radio-group v-model="indexMedicine" size="mini"
                                                                :disabled="isMedicineTypeConverting"
                                                                @change="changeMedicineType()">
                                                    <el-radio-button label="0">颗粒</el-radio-button>
                                                    <el-radio-button label="1">饮片</el-radio-button>
                                                    <el-radio-button label="2">膏方</el-radio-button>
                                                    <el-radio-button label="3">水丸</el-radio-button>
                                                </el-radio-group>
                                            </div>
                                        </el-col>

                                        <el-col :span="24">
                                            <div class="alert_info_title">
                                            <span
                                                v-if="medicalOrder.billingType === '0'">*颗粒请按饮片剂量开方，药房自动转换!</span>
                                                <span v-if="medicalOrder.billingType === '1'">*饮片代煎{{
                                                        medicineViceNumPrice
                                                    }}元/剂!</span>
                                                <span v-if="medicalOrder.billingType === '2'">*药材总量{{
                                                        gao_line
                                                    }}g起做，加工费{{ medicineGaoStartPrice }}元/{{
                                                        gao_line
                                                    }}g!</span>
                                                <span v-if="medicalOrder.billingType === '3'">*药材总量{{
                                                        shui_line
                                                    }}g起做，加工费{{ medicineShuiStartPrice }}元/{{
                                                        shui_line
                                                    }}g!</span>
                                            </div>
                                        </el-col>

                                        <!-- 颗粒的新标开启-->
                                        <el-col :span="24">
                                            <div class="med_con_div flex_c_left"
                                                 v-if="(medicalOrder.billingType === '0' || medicalOrder.billingType === 0) && newRuleOpen">
                                                <div class="med_con_tent flex_c_left flex_c_wrap">
                                                    <div class="med_con_tit flex_c_left"><span
                                                        class="font_gold font_w mrr10">已启用</span>新标剂量转换设置
                                                    </div>
                                                    <div class="med_con_info flex_c_left">
                                                        新标药材系统将自动转换为新标剂量
                                                    </div>
                                                </div>
                                            </div>
                                        </el-col>

                                        <!-- 药材列表-->
                                        <el-col :span="24">
                                            <div class="med_table_con">
                                                <el-row class="med_thead" :gutter="20">
                                                    <el-col :span="12">
                                                        <span>Rp:</span>
                                                        <span class="alert_info_span">共 {{ docMedicineArray.length }} 味药材，
                                                        每剂 {{ parseFloat(medSingleCounPrice).toFixed(2) }} 元，共 {{
                                                                parseFloat(orderMedicalCountPrice).toFixed(2)
                                                            }} 元</span>
                                                    </el-col>
                                                    <el-col class="me_btn_con" :span="12">
                                                        <el-button type="primary" icon="CircleCheckFilled" size="small"
                                                                   round
                                                                   :disabled="isMedicineTypeConverting"
                                                                   @click="openChooseMedicinalDrawer()"
                                                                   v-if="docMedicineArray.length <= 0">选择药材
                                                        </el-button>
                                                        <el-button type="danger" icon="Edit" size="small" round
                                                                   :disabled="isMedicineTypeConverting"
                                                                   @click="openChooseMedicinalDrawer()"
                                                                   v-if="docMedicineArray.length > 0">修改药材
                                                        </el-button>
                                                        <el-button type="warning" icon="UploadFilled" size="small" round
                                                                   :disabled="isMedicineTypeConverting"
                                                                   @click="openPrescriptionDrew()">导入处方模版
                                                        </el-button>
                                                    </el-col>
                                                </el-row>

                                                <div class="med_tbody" v-loading="isMedicineTypeConverting"
                                                     element-loading-text="正在转换药材...">
                                                    <div class="med_list_con flex_left_warp"
                                                         v-if="docMedicineArray.length > 0">
                                                        <div class="med_list_li flex_c_between"
                                                             v-for="(item, index) in docMedicineArray"
                                                             :key="index">
                                                            <!-- 超量签章水印（左上角） -->
                                                            <div class="usage_sign_badge" v-if="item.isOverLimit">
                                                                {{ item.usageSignName }}
                                                            </div>
                                                            <!-- 超量提示（底部浮动） -->
                                                            <div class="usage_sign_remark" v-if="item.isOverLimit">
                                                                {{ item.usageSignRemark }}
                                                            </div>
                                                            <div class="width100">
                                                                <span class="text14 font_gold" v-if="item.standard !== null && item.standard !== undefined && item.standard !== ''
                                                                 && (medicalOrder.billingType === '0' || medicalOrder.billingType === 0)  && newRuleOpen">[{{ item.standard }}]</span>
                                                                <span class="med_li_name">{{ item.meName }}</span>
                                                                <span v-if="item.meStatus === '1'"
                                                                      class="med_li_status"><span
                                                                    class="med_li_info flex_c_right"></span></span>
                                                                <span class="text14 font_gold"
                                                                      v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{ item.drugProperty }})</span>
                                                                <span class="text14 font_orange" v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== ''
                                                                 && (medicalOrder.billingType !== '0' && medicalOrder.billingType !== 0) && item.decoctionName !== '无'">({{ item.decoctionName }})</span>
                                                            </div>
                                                            <div class="font_gray mrl10">{{ item.newGCount }}g</div>
                                                        </div>
                                                    </div>
                                                    <el-empty image-size="56" description="暂无药材信息"
                                                              v-if="docMedicineArray.length <= 0">
                                                        <el-button type="primary" size="small" plain icon="Plus" round
                                                                   :disabled="isMedicineTypeConverting"
                                                                   @click="openChooseMedicinalDrawer()">添加药材
                                                        </el-button>
                                                    </el-empty>
                                                </div>

                                                <el-row class="med_foot" :gutter="20">
                                                    <el-col :span="14">
                                                        <el-radio-group v-model="medicalOrder.takeWay"
                                                                        v-if="medicalOrder.billingType === '0' || medicalOrder.billingType === '1'">
                                                            <el-radio label="0">内服</el-radio>
                                                            <el-radio label="1">外用</el-radio>
                                                        </el-radio-group>
                                                        <div class="flex_t_col"
                                                             v-if="medicalOrder.billingType === '2'">
                                                            <el-col class="med_info_more flex_c_left" :span="24">
                                                                <el-radio-group v-model="medicalOrder.packWay">
                                                                    <el-radio label="0">袋装</el-radio>
                                                                    <el-radio label="1">瓶装</el-radio>
                                                                </el-radio-group>
                                                            </el-col>
                                                            <el-col class="med_info_more flex_c_left" :span="24">
                                                        <span class="alert_info_span3"
                                                              v-if="medicalOrder.packWay === '0'">单个袋装的容量约为20~30ml!</span>
                                                                <span class="alert_info_span3"
                                                                      v-if="medicalOrder.packWay === '1'">单瓶包装的容量约为250~500ml</span>
                                                            </el-col>
                                                        </div>
                                                        <div class="flex_t_col"
                                                             v-if="medicalOrder.billingType === '3'">
                                                            <el-col class="med_info_more flex_c_left" :span="24">
                                                                <span>每日</span>
                                                                <el-input-number controls-position="right"
                                                                                 class="med_input"
                                                                                 placeholder="剂量" min="0"
                                                                                 v-model="medicalOrder.takeTimes"
                                                                                 @focus="focus($event)"></el-input-number>
                                                                <span>次，每次</span>
                                                                <el-input-number controls-position="right"
                                                                                 class="med_input"
                                                                                 placeholder="剂量" min="0"
                                                                                 v-model="medicalOrder.timeUseNum"
                                                                                 @focus="focus($event)"></el-input-number>
                                                                <span>g</span>
                                                            </el-col>
                                                        </div>
                                                    </el-col>
                                                    <el-col class="med_foot_info" :span="10"
                                                            v-if="docMedicineArray.length > 0">
                                                        <el-button type="primary" icon="Finished" size="small" round
                                                                   @click="saveTemp()">保存为处方模版
                                                        </el-button>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form class="med_body_floor_bottom" ref="form" :model="patientInfo"
                                                     label-position="left"
                                                     label-width="90px">
                                                <el-row :gutter="20" v-if="medicalOrder.billingType === '1'">
                                                    <el-col :span="8">
                                                        <el-form-item label="饮片煎法">
                                                            <el-radio-group v-model="medicalOrder.decoctType"
                                                                            @change="chooseJian()">
                                                                <el-radio label="1">代煎</el-radio>
                                                                <el-radio label="0">自煎</el-radio>
                                                            </el-radio-group>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>
                                                <el-row :gutter="20"
                                                        v-if="medicalOrder.billingType === '1' && this.medicalOrder.decoctType==='1'">
                                                    <el-col :span="8">
                                                        <el-form-item label="代煎规格">
                                                            <el-radio-group v-model="medicalOrder.specification">
                                                                <el-radio label="200">200ml</el-radio>
                                                                <el-radio label="100">100ml</el-radio>
                                                            </el-radio-group>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col class="flex_c_left" :span="8">
                                                <span
                                                    class="alert_information">*当前药房可选代煎包装规格，默认200ml袋装规格!</span>
                                                    </el-col>
                                                </el-row>
                                                <el-row :gutter="20"
                                                        v-if="medicalOrder.billingType === '0' || medicalOrder.billingType === '1'">
                                                    <el-col :span="24">
                                                        <el-form-item label="剂量说明">
                                                            <span>共</span>
                                                            <el-input-number :step="1" controls-position="right"
                                                                             min="0"
                                                                             class="med_input" placeholder="剂量"
                                                                             v-model="medicalOrder.viceNum"
                                                                             @input="changeViceNum()"
                                                                             @change="changeViceNum()"
                                                                             @focus="focus($event)"></el-input-number>
                                                            <span>剂，</span>
                                                            <el-input-number :step="1" controls-position="right"
                                                                             min="0"
                                                                             class="med_input" placeholder="用量"
                                                                             v-model="medicalOrder.dayTakeNum"
                                                                             @focus="focus($event)"></el-input-number>
                                                            <span>日1剂，每日分</span>
                                                            <el-input-number :step="1" controls-position="right"
                                                                             min="0"
                                                                             class="med_input" placeholder="用量"
                                                                             v-model="medicalOrder.takeTimes"
                                                                             @input="changeDrinkTimes()"
                                                                             @change="changeDrinkTimes()"
                                                                             @focus="focus($event)"></el-input-number>
                                                            <span>次服用</span>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>
                                                <el-row :gutter="20" v-if="medicalOrder.billingType === '1'">
                                                    <el-col :span="16">
                                                        <span class="alert_info_span3">总共{{
                                                                medicalOrder.allViceNum
                                                            }}包，每次1包</span>
                                                    </el-col>
                                                </el-row>

                                                <!-- 辅料 -->
                                                <el-row :gutter="20" v-if="medicalOrder.billingType === '2'">
                                                    <el-col :span="22">
                                                        <el-form-item label="辅料(必填)">
                                                            <div class="fuliao_con">
                                                                <div class="fuliao_line flex_c_left"
                                                                     v-for="(item, index) in chooseFuliaoList"
                                                                     :key="index">
                                                                    <el-col class="med_name_icon flex_c" :span="1">
                                                                        <el-tooltip class="box-item"
                                                                                    :content="item.meDesc"
                                                                                    placement="top-start"
                                                                                    v-if="item.meDesc !== null && item.meDesc !== undefined && item.meDesc !== ''">
                                                                            <div class="med_name_icon flex_c">
                                                                                <el-icon size="20" color="#999999">
                                                                                    <InfoFilled/>
                                                                                </el-icon>
                                                                            </div>
                                                                        </el-tooltip>
                                                                    </el-col>
                                                                    <el-col class="med_name_con" :span="8">
                                                                        <el-select class="med_select_style"
                                                                                   v-model="item.medicineId"
                                                                                   @change="chooseFuliaoFunc(item)"
                                                                                   placeholder="药品名称">
                                                                            <el-option-group
                                                                                v-for="group in fuliaoList"
                                                                                :key="group.typeName"
                                                                                :label="group.typeName">
                                                                                <el-option
                                                                                    v-for="meList in group.meList"
                                                                                    :key="meList.medicineId"
                                                                                    :label="meList.meName"
                                                                                    :value="meList.medicineId"
                                                                                    :disabled="meList.isChoosed"
                                                                                >
                                                                            <span style="float: left">{{
                                                                                    meList.meName
                                                                                }}</span>
                                                                                    <span
                                                                                        style="float: right; color: var(--el-text-color-secondary); font-size: 13px;">{{
                                                                                            meList.price
                                                                                        }}元/g</span>
                                                                                </el-option>
                                                                            </el-option-group>
                                                                        </el-select>
                                                                    </el-col>
                                                                    <el-col :span="6">
                                                                        <el-input type="number"
                                                                                  :ref="'meCount'+item.medicineId"
                                                                                  :step="10" placeholder="克数"
                                                                                  min="0"
                                                                                  @focus="focus($event)"
                                                                                  v-model="item.meCount"
                                                                                  @input="changeFuliaoCount(item)">
                                                                            <template #append>g</template>
                                                                        </el-input>
                                                                    </el-col>
                                                                    <el-col :span="5">
                                                                        <div class="flex_c_right font_red">￥{{
                                                                                item.countPrice
                                                                            }}
                                                                        </div>
                                                                    </el-col>
                                                                    <el-col :span="4">
                                                                        <el-button circle size="small"
                                                                                   type="primary"
                                                                                   @click="toAddFuliaoMedical()">
                                                                            <el-icon>
                                                                                <Plus/>
                                                                            </el-icon>
                                                                        </el-button>
                                                                        <el-button circle size="small" type="danger"
                                                                                   v-if="index!==0"
                                                                                   @click="deleteFuliao(item.medicineId)">
                                                                            <el-icon>
                                                                                <DeleteFilled/>
                                                                            </el-icon>
                                                                        </el-button>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>

                                                <el-row :gutter="20" v-if="medicalOrder.billingType === '2'">
                                                    <el-col :span="24">
                                                        <el-form-item label="剂量说明">
                                                            <span>每日</span>
                                                            <el-input-number :step="1" controls-position="right"
                                                                             class="med_input" placeholder="剂量"
                                                                             v-model="medicalOrder.takeTimes"
                                                                             @focus="focus($event)"></el-input-number>
                                                            <span>次，每次</span>
                                                            <el-input-number :step="1" controls-position="right"
                                                                             class="med_input" placeholder="剂量"
                                                                             v-model="medicalOrder.timeUseNum"
                                                                             @focus="focus($event)"></el-input-number>
                                                            <span v-if="medicalOrder.packWay==='0'">袋</span>
                                                            <span v-if="medicalOrder.packWay==='1'">ml</span>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>
                                                <el-row :gutter="20"
                                                        v-if="medicalOrder.billingType === '2' && medicineHeavy > 0">
                                                    <el-col :span="24">
                                                <span class="alert_info_span4">*注：药材总重<span
                                                    class="price_red">{{ medicineHeavy }}</span>g,预计出膏<span
                                                    class="price_red">{{ gao_heavy_low }}g~{{ gao_heavy_high }}g</span>；
                                                    预计出膏率占药材总重<span
                                                        class="price_red">{{ gao_rate_low }}%~{{
                                                            gao_rate_high
                                                        }}%</span></span>
                                                    </el-col>
                                                </el-row>

                                                <el-row :gutter="20"
                                                        v-if="medicalOrder.billingType === '3' && medicineHeavy > 0">
                                                    <el-col :span="16">
                                                <span class="alert_info_span4">*注：药材总重<span
                                                    class="price_red">{{ medicineHeavy }}g</span>,
                                                    预计制丸<span
                                                        class="price_red">{{ shui_heavy_low }}g~{{
                                                            shui_heavy_high
                                                        }}g</span>；预计出丸率占药材总重<span
                                                        class="price_red">{{ shui_rate_low }}%~{{
                                                            shui_rate_high
                                                        }}%</span></span>
                                                    </el-col>
                                                </el-row>
                                            </el-form>
                                        </el-col>
                                    </div>

                                </div>

                                <!--医嘱用法-->
                                <div class="prescription_tab_panel">
                                    <div class="title_in_body flex_c_left">
                                        <div class="title_span flex_c_left">
                                            <span>医嘱用法</span>
                                            <span
                                                class="alert_info_span">*请按需选择用法禁忌，如需标注其他内容请填写在特殊说明中!</span>
                                        </div>
                                    </div>
                                    <div class="med_body_2">
                                        <el-form class="med_body_floor" ref="form" :model="patientInfo"
                                                 label-position="left"
                                                 label-width="90px">
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="18">
                                                    <el-form-item
                                                        label="用&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;法">
                                                        <el-select v-model="medicalOrder.useWay"
                                                                   placeholder="请选择用法">
                                                            <el-option :label="item" :value="item"
                                                                       v-for="(item, index) in useWayList"
                                                                       :key="index"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="18">
                                                    <el-form-item
                                                        label="禁&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;忌">
                                                        <el-select v-model="useAttention" multiple
                                                                   placeholder="请选择禁忌"
                                                                   @change="useAttentionChoose()">
                                                            <el-option :label="item" :value="item"
                                                                       v-for="(item, index) in tabooList"
                                                                       :key="index"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="18">
                                                    <el-form-item label="特殊说明">
                                                        <el-input type="textarea" placeholder="请输入特殊说明"
                                                                  maxlength="500"
                                                                  show-word-limit
                                                                  v-model="medicalOrder.docAdvice"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-form>
                                    </div>
                                </div>

                                <!--配送方式-->
                                <div class="prescription_tab_panel">
                                    <div class="title_in_body flex_c_left">
                                        <div class="title_span flex_c_left">
                                            <span>药方配送</span>
                                            <span
                                                class="alert_info_span">*门诊开方默认配送方式为门诊自取，请在开方前询问实际取药方式，如需配送，请填写收获地址！</span>
                                        </div>
                                    </div>
                                    <div class="med_body_2">
                                        <el-form class="med_body_floor" ref="form" :model="patientInfo"
                                                 label-position="right"
                                                 label-width="auto">
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="18">
                                                    <el-radio-group v-model="medicalOrder.deliverWay" size="mini"
                                                                    @change="changeDeliverWayType()">
                                                        <el-radio-button label="1">门诊自取</el-radio-button>
                                                        <el-radio-button label="0">物流配送</el-radio-button>
                                                    </el-radio-group>
                                                </el-col>
                                            </el-row>
                                            <div class="el_row_width3 send_body" style="margin-top: 30px" :gutter="20"
                                                 v-if="medicalOrder.deliverWay==1">
                                                <el-col class="mrb20" :span="18">
                                                    <h3>二七知夏中医门诊部</h3>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="联系电话">
                                                        <span class="font_weight">0371-86103049</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="营业时间">
                                                        <span class="font_weight">周一至周日 8:30-18:30</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="自取地址">
                                                    <span
                                                        class="font_weight">河南省郑州市二七区五里堡街道建设东路49号中投汇金城北门旁（导航搜索：知夏中医）</span>
                                                    </el-form-item>
                                                </el-col>
                                            </div>
                                            <div class="el_row_width3 send_body" :gutter="20"
                                                 v-if="medicalOrder.deliverWay==0">
                                                <el-col class="mrb10" :span="24">
                                                    <el-alert
                                                        title="物流配送地址默认为患者常住地址信息，请咨询患者后，按实际需要填写或修改的收货地址！"
                                                        type="warning" :closable="false" show-icon>
                                                        <template #icon>
                                                            <InfoFilled/>
                                                        </template>
                                                    </el-alert>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="收货人姓名">
                                                        <el-input type="text" placeholder="请填写收货人姓名"
                                                                  v-model="medicalOrder.receivePersonName"
                                                                  clearable></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="收货人手机号码">
                                                        <el-input type="text" placeholder="请填写收货人手机号码"
                                                                  v-model="medicalOrder.receivePhone"
                                                                  clearable></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="所在省/市/区">
                                                        <el-cascader style="width: 100%;" :options="regionData"
                                                                     v-model="receiveRegion"
                                                                     placeholder="请选择所在省/市/区"
                                                                     @change="chooseRegionData()"></el-cascader>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="18">
                                                    <el-form-item class="mrb10" label="收货人详情地址">
                                                        <el-input type="textarea" placeholder="请填写收货人详情地址"
                                                                  maxlength="500"
                                                                  show-word-limit
                                                                  v-model="medicalOrder.receiveAddress"
                                                                  clearable></el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </div>
                                        </el-form>
                                    </div>
                                </div>

                                <!--费用设置-->
                                <div class="prescription_tab_panel">
                                    <div class="title_in_body flex_c_left">
                                        <div class="title_span flex_c_left">
                                            <span>费用设置</span>
                                        </div>
                                    </div>
                                    <div class="med_body_2">
                                        <el-form class="med_body_floor" ref="form" :model="patientInfo"
                                                 label-position="left"
                                                 label-width="100px">
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="24">
                                                    <el-form-item label="诊后病程管理">
                                                        <div class="el_row_content flex_t_col">
                                                            <div class="el_row_content flex_c_left">
                                                                <span>费用共 </span>
                                                                <span class="diseasefee_fee_daily"
                                                                      v-if="!editAdjustmentPrice">¥ {{
                                                                        medicalOrder.adjustmentPrice
                                                                    }}</span>
                                                                <span class="mrl10" v-if="editAdjustmentPrice">¥
                                                                <el-select style="width: 160px;margin: 0 6px"
                                                                           v-model="medicalOrder.adjustmentPrice"
                                                                           placeholder="请选择诊后病程管理费用"
                                                                           @change="changeAdjustmentPrice()">
                                                                    <el-option :label="item" :value="item"
                                                                               v-for="(item, index) in feeOptions"
                                                                               :key="index"></el-option>
                                                                </el-select>
                                                            </span>
                                                                <span>，{{ dailyFeeText.prefix }}</span>
                                                                <span class="diseasefee_fee_daily">{{
                                                                        dailyFeeText.amount
                                                                    }}</span>
                                                                <span>，服务 <span class="diseasefee_fee_daily">{{
                                                                        serviceDays
                                                                    }}</span> 天</span>

                                                                <el-button type="primary" round size="small"
                                                                           class="mrl20"
                                                                           @click="editAdjustmentPriceValue()"
                                                                           v-if="!editAdjustmentPrice">点击设置
                                                                </el-button>
                                                                <el-button type="primary" round size="small"
                                                                           class="mrl20"
                                                                           @click="sureEditAdjustmentPriceValue()"
                                                                           v-if="editAdjustmentPrice">确定
                                                                </el-button>
                                                                <el-button type="danger" round size="small"
                                                                           class="mrl10"
                                                                           @click="cancelEditAdjustmentPriceValue()"
                                                                           v-if="editAdjustmentPrice">取消
                                                                </el-button>
                                                            </div>
                                                            <div class="width100 font_w font_orange">当前病程管理费最高可设置
                                                                {{ maxFee }} 元
                                                            </div>
                                                            <div class="width100">
                                                                请参考该患者病情严重程度、疗程时长及您的诊后病程管理内容设置费用
                                                            </div>
                                                        </div>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row class="el_row_width3" :gutter="20">
                                                <el-col :span="8">
                                                    <el-form-item class="flex_c_right"
                                                                  label="就诊诊金">
                                                        <el-select v-model="medicalOrder.docPrice"
                                                                   placeholder="请选择就诊诊金"
                                                                   @change="changeDocPrice()">
                                                            <el-option :label="item" :value="item"
                                                                       v-for="(item, index) in docFeeOptions"
                                                                       :key="index"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <span style="margin-top: 4px">元</span>
                                            </el-row>
                                        </el-form>
                                    </div>
                                </div>

                                <!--费用明细-->
                                <div class="prescription_tab_panel">
                                    <div class="title_in_body flex_c_left">
                                        <div class="title_span flex_c_left">费用明细</div>
                                    </div>

                                    <div class="med_body_2">
                                        <el-row class="el_row_width3" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item class="mrb10 font_14" label="药材费用">
                                                <span class="price_red">￥{{
                                                        parseFloat(orderMedicalCountPrice).toFixed(2)
                                                    }}</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width3" :gutter="20">
                                            <el-col :span="24" v-if="medicalOrder.billingType !== '0'">
                                                <el-form-item class="mrb10 font_14" label="加工费用">
                                                        <span class="price_red">￥{{
                                                                parseFloat(medicalOrder.processingCosts).toFixed(2)
                                                            }}</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width3" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item class="mrb10 font_14" label="诊金">
                                                <span class="price_red">￥{{
                                                        parseFloat(medicalOrder.docPrice).toFixed(2)
                                                    }}</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width3" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item class="mrb10 font_14" label="诊后病程管理费用">
                                                        <span class="price_red">￥{{
                                                                parseFloat(medicalOrder.adjustmentPrice).toFixed(2)
                                                            }}</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row class="el_row_width3 mrb10" :gutter="20">
                                            <el-col :span="24">
                                                <el-form-item class="mrb10 font_14" label="费用总计">
                                                <span class="price_red font_weight">￥{{
                                                        parseFloat(medicalOrder.orderPrice).toFixed(2)
                                                    }}</span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="el_action_btn">
                            <el-button type="success" round :loading="multiPrescriptionSubmitting"
                                       :disabled="multiPrescriptionSubmitting" @click="saveMedicalOrder()">
                                提交{{ prescriptionDrafts.length > 1 ? '全部药方' : '' }}
                            </el-button>
                            <el-button type="info" round :disabled="multiPrescriptionSubmitting"
                                       @click="resetMedical()">重&nbsp;&nbsp;&nbsp;置</el-button>
                        </div>
                    </el-col>
                    <!-- 历史病历 -->
                    <el-col class="content_body flex_c_between" :span="9">
                        <div class="el_col_div"></div>
                        <div class="content_body_right">
                            <div class="title_body title_con flex_c_left">
                                <div class="title_line"></div>
                                <div class="title_span flex_c_left">
                                <span
                                    v-if="this.patientInfo.name !== null && this.patientInfo.name !== '' && this.patientInfo.name !== undefined">
                                    <span class="font_orange mrr5">{{ this.patientInfo.name }}</span>的</span>
                                    <span>历史病历</span>
                                    <span
                                        v-if="this.patientInfo.name !== null && this.patientInfo.name !== '' && this.patientInfo.name !== undefined">（ {{
                                            recordTotal
                                        }} ）</span>
                                </div>
                            </div>
                            <!-- 搜索-->
                            <div class="history_order_search flex_c_left">
                                <el-input v-model="queryRecordParams.keyWords" placeholder="搜索关键字（诊断）"
                                          clearable/>
                                <el-button class="mrl20" type="primary" icon="Search"
                                           @click="getPatientHiMedicalOrderdList()">搜索
                                </el-button>
                            </div>

                            <!-- 列表-->
                            <div class="history_order_con" style="overflow-y:auto;overflow-x: hidden">
                                <div v-infinite-scroll="loadMorePatientHiMedicalOrder"
                                     :infinite-scroll-immediate="false" v-loading="recordTableLoading"
                                     :infinite-scroll-disabled="recordLoadDisabled">
                                    <!-- 空列表-->
                                    <el-empty style="height: 100%" image-size="56" description="暂无历史病历"
                                              v-if="recordlist.length <= 0"></el-empty>
                                    <div class="history_order_li flex_t_col" v-for="(medlist, inx) in recordlist"
                                         :key="inx">
                                        <div class="his_order_title flex_c_between">
                                            <div class="flex_c_left font_14">
                                                <el-tag size="small" :type="medlist.orderSource === 'clinic' || medlist.orderSource === 'clinicRepeat' ? 'parmary':
                                                medlist.orderSource === 'patient' || medlist.orderSource === 'patientRepeat' ? 'danger':'success'">
                                                    {{
                                                        medlist.orderSource === 'clinic' || medlist.orderSource === 'clinicRepeat' ? '门诊' : medlist.orderSource === 'patient' || medlist.orderSource === 'patientRepeat' ? '患' : '医'
                                                    }}
                                                </el-tag>
                                                <span class="mrl5" v-if="medlist.orderKind !== '1'"><el-tag size="small"
                                                                                                            type="danger">{{
                                                        medlist.billingType === '1' ? '饮片' : medlist.billingType === '2' ? '膏方' : medlist.billingType === '3' ? '水丸' : '颗粒'
                                                    }}</el-tag></span>
                                                <span class="mrl5"><span class="font_w">NO.</span>{{ medlist.serialNo }}</span>
                                                <el-tag class="mrl5" size="small" type="info"
                                                        v-if="medlist.orderKind === '1'">病历单
                                                </el-tag>
                                            </div>
                                            <div class="flex_c_right font_weight font_gray font_14"
                                                 v-if="medlist.orderKind !== '1'">
                                                <span :class="medlist.status === '1' || medlist.status === '6' ? 'text-blue':
                                                medlist.status === '2' || medlist.status === '5' ? 'text-orange':
                                                medlist.status === '3' || medlist.status === '4' ? 'text-red':'text-grey1'">{{
                                                        getOrderStatus(medlist.status)
                                                    }}</span>
                                            </div>
                                            <div class="flex_c_right font_weight font_gray font_14"
                                                 v-if="medlist.orderKind === '1'">
                                                <span class="text-grey1">已完成</span>
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind === '1'">
                                            <div class="his_info_tit">主诉：</div>
                                            <div class="his_info_con font_weight">
                                                {{ medlist.mainSuit === null ? '无' : medlist.mainSuit }}
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14">
                                            <div class="his_info_tit">诊断结果：</div>
                                            <div class="his_info_con font_weight">
                                                {{
                                                    medlist.clinicalDiagnosis === null ? '无' : medlist.clinicalDiagnosis
                                                }}
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind === '1'">
                                            <div class="his_info_tit">既往史：</div>
                                            <div class="his_info_con font_weight">
                                                {{
                                                    medlist.patientMedicalHistory === null ? '无' : medlist.patientMedicalHistory
                                                }}
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind === '1'">
                                            <div class="his_info_tit">现病史：</div>
                                            <div class="his_info_con font_weight">
                                                {{
                                                    medlist.nowMedicalHistory === null ? '无' : medlist.nowMedicalHistory
                                                }}
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind !== '1'">
                                            <div class="his_info_tit">药方详情：</div>
                                            <div class="his_info_con">每剂{{ medlist.orderMedicineList.length }} 味药，共{{
                                                    medlist.viceNum
                                                }}剂，总重{{
                                                    getOrderWeightByNewGCount(medlist.orderMedicineList)
                                                }}g
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind !== '1'">
                                            <div class="his_info_tit">费用合计：</div>
                                            <div class="his_info_con font_weight font_gold">￥{{
                                                    medlist.orderPrice
                                                }}
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14"
                                             v-if="medlist.orderKind !== '1'">
                                            <div class="his_info_tit">配送方式：</div>
                                            <div class="his_info_con">
                                                <el-tag size="small"
                                                        :type="medlist.deliverWay === '1' ? 'success' : 'danger'">
                                                    {{ medlist.deliverWay === '1' ? '门诊自取' : '物流配送' }}
                                                </el-tag>
                                            </div>
                                        </div>
                                        <div class="his_order_info flex_t_between font_black font_14">
                                            <div class="his_info_tit">药材清单：</div>
                                            <div class="his_info_con" v-if="medlist.orderKind !== '1'">
                                                <span class="mrr10" v-for="(item, index) in medlist.orderMedicineList"
                                                      :key="index">
                                                    <span class="font_gold" v-if="item.standard !== null && item.standard !== undefined && item.standard !== ''
                                                            && (medlist.billingType === '0' || medlist.billingType === 0)  && newRuleOpen">[{{
                                                            item.standard
                                                        }}]</span>
                                                    <span class="font_weight mrr5">{{ item.meName }}</span>
                                                    <span class="font_gold"
                                                          v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                                            item.drugProperty
                                                        }})</span>
                                                    <span class="font_gray"
                                                          v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{
                                                            item.decoctionName
                                                        }})</span>
                                                    <span class="font_gray mrl5">{{ item.newGCount }}g</span>
                                                </span>
                                            </div>
                                            <div class="his_info_con text-grey1" v-if="medlist.orderKind === '1'">
                                                暂未开方，无药材清单
                                            </div>
                                        </div>
                                        <div class="his_order_btn flex_c_between">
                                            <div class="flex_c_left font_black font_14">
                                                <el-tooltip content="门诊病历" placement="bottom" effect="dark">
                                                    <el-button class="cursor" type="success" size="small" circle
                                                               icon="UserFilled"
                                                               @click="openBingliInfo(medlist.orderId)"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="药方详情" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="primary" size="small" circle
                                                               icon="List"
                                                               @click="openOrderDetail(medlist.orderId, medlist.status)"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="再来一单" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="warning" size="small" circle
                                                               icon="Refresh"
                                                               @click="oneMoreOrder(medlist.orderId)"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="修改订单" placement="bottom" effect="dark">
                                                    <el-button class="cursor" type="warning" size="small" circle
                                                               icon="EditPen" @click="userEditOrder(medlist.orderId)"
                                                               v-if="medlist.orderKind === '1' || medlist.status === '1' || medlist.status === '3'"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="处方笺打印" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="success" size="small" circle
                                                               icon="Printer"
                                                               @click="exportOrder(medlist.orderId)"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="取消订单" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="danger" size="small" circle
                                                               icon="CloseBold"
                                                               @click="userCancelOrder(medlist.orderId)"
                                                               v-if="medlist.status === '1' || medlist.status === '3'"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="订单收费" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="success" size="small" circle
                                                               icon="Switch" @click="openPayScreen(medlist.orderId)"
                                                               v-if="medlist.status === '3'"></el-button>
                                                </el-tooltip>
                                                <!-- 查询收款结果：弹窗关闭后仍能补查（只读查单，绝不发起扣款） -->
                                                <el-tooltip content="查询收款结果" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind !== '1'">
                                                    <el-button class="cursor" type="warning" size="small" circle
                                                               icon="Search" @click="queryListPayResult(medlist)"
                                                               v-if="medlist.status === '3'"></el-button>
                                                </el-tooltip>
                                                <el-tooltip content="删除病历单" placement="bottom" effect="dark"
                                                            v-if="medlist.orderKind === '1'">
                                                    <el-button class="cursor" type="danger" size="small" circle
                                                               icon="Delete"
                                                               @click="userDeleteCaseOrder(medlist.orderId)"></el-button>
                                                </el-tooltip>
                                            </div>
                                            <div class="flex_c_right font_gray font_14">{{ medlist.orderDate }}</div>
                                        </div>
                                    </div>
                                </div>
                                <p class="flex_c" v-if="!recordLoadDisabled && recordTableLoading">
                                    正在加载更多数据...</p>
                                <p class="flex_c" v-if="recordLoadDisabled">没有更多数据了</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>


        <!-- 选择药材模版-->
        <el-drawer :with-header="false" v-model="medicinalChooseDrawer" :direction="direction" destroy-on-close
                   size="48%" :modal="true" @close="closeMedicinalChooseDrawer()"
                   style="background: #f5f7fa">
            <div class="drawer_con">
                <div class="drawer_title">
                    <span>药材管理</span>
                    <el-icon class="drawer_icon" @click="closeMedicinalChooseDrawer()">
                        <close-bold/>
                    </el-icon>
                </div>
                <div class="medicinal_con">
                    <Medicinal ref="medicinalChoose" :pagename="pagename"
                               @medicinalDrawerStatus="getMedicinalDrawerStatus()"></Medicinal>
                </div>
            </div>
        </el-drawer>


        <!-- 导入处方模版-->
        <el-drawer :with-header="false" v-model="prescriptionDialogVisible" :direction="direction" destroy-on-close
                   size="32%" :modal="true"
                   style="background: #f5f7fa">
            <div class="drawer_con">
                <div class="drawer_title">
                    <span>导入处方模版</span>
                    <el-icon class="drawer_icon" @click="getPreDrawerStatus()">
                        <close-bold/>
                    </el-icon>
                </div>
                <Prescription @preDrawerStatus="getPreDrawerStatus()"></Prescription>
            </div>
        </el-drawer>


        <!--订单详情-->
        <el-drawer :with-header="false" v-model="orderDetailDialogVisible" :direction="direction" destroy-on-close
                   size="36%" :modal="true" @close="closeOrderDetail()"
                   style="background: #f5f7fa">
            <div class="drawer_con">
                <div class="drawer_title">
                    <span>订单详情</span>
                    <el-icon class="drawer_icon" @click="orderDetailDialogVisible = false">
                        <close-bold/>
                    </el-icon>
                </div>
                <Orderdetail @orderDetailStatus="getOrderDetailStatus()" :orderId="orderId"></Orderdetail>
            </div>
        </el-drawer>


        <!--新增自建模版-->
        <el-dialog
            title="新增自建模版"
            v-model="addDialogVisible"
            width="32%">
            <div class="dislog_con">
                <el-form ref="form" :model="prescriptionInfo" label-width="140px">
                    <el-form-item label="模版名称" :rules="[{required: true}]">
                        <el-input placeholder="请输入模版名称" v-model="prescriptionInfo.preName"></el-input>
                    </el-form-item>
                    <el-form-item label="适应病症">
                        <el-input placeholder="请输入模版适应病症" v-model="prescriptionInfo.instructions"></el-input>
                    </el-form-item>
                    <el-form-item label="处方剂型" :rules="[{required: true}]">
                        <el-radio-group v-model="prescriptionInfo.billingType" @change="changeMedicineType()">
                            <el-radio label="0">颗粒</el-radio>
                            <el-radio label="1">饮片</el-radio>
                            <el-radio label="2">膏方</el-radio>
                            <el-radio label="3">水丸</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否置顶">
                        <el-switch
                            v-model="prescriptionInfo.isTop"
                            :active-value="0"
                            :inactive-value="1">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="药材列表" :rules="[{required: true}]">
                        <div class="med_list_con">
                            <div class="pre_med_top flex_c_between">
                                <div class="font_gold">共有 {{ prescriptionInfo.docPrescriptionMedicineList.length }}
                                    味药材
                                </div>
                                <!--                                <el-button type="danger" size="small" icon="Edit" @click="openChooseMedicinalDrawer()">修改药材</el-button>-->
                            </div>
                            <div class="pre_med_list_con">
                                <div class="med_list_con flex_left_warp"
                                     v-if="prescriptionInfo.docPrescriptionMedicineList.length > 0">
                                    <div class="pre_med_list_li flex_c_between"
                                         v-for="(item, index) in prescriptionInfo.docPrescriptionMedicineList"
                                         :key="index">
                                        <span class="font_gold"
                                              v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && medicalOrder.billingType === '0' && newRuleOpen">[{{
                                                item.standard
                                            }}]</span>
                                        <span class="med_li_name">{{ item.meName }}</span>
                                        <span class="font_gold"
                                              v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                                item.drugProperty
                                            }})</span>
                                        <span class="font_gray"
                                              v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{
                                                item.decoctionName
                                            }})</span>
                                        <span class="font_gray mrl10">{{ item.gCount }}g</span>
                                    </div>
                                </div>
                                <el-empty image-size="48" description="暂无药材信息"
                                          v-if="prescriptionInfo.docPrescriptionMedicineList.length <= 0">
                                    <el-button type="text" @click="openChooseMedicinalDrawer()">添加药材</el-button>
                                </el-empty>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelPrescriptionFun()">取  消</el-button>
                    <el-button type="primary" @click="savePrescriptionFun()">保  存</el-button>
                </span>
            </template>

        </el-dialog>

        <!-- 处方笺预览-->
        <el-dialog v-model="prescriptionPaperDialogVisible" width="600px" center :close-on-click-modal="false">
            <div class="prescriptionPaperDialog" id="printArea">
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="isLoadingPrintData">
                    <el-icon class="pay_loading_icon is-loading">
                        <loading/>
                    </el-icon>
                    <div class="pay_loading_text">正在查询，请稍候...</div>
                </div>
                <div class="paper_title_con">
                    <div class="paper_title">知夏中医门诊部专用处方笺</div>
                </div>
                <div class="paper_line flex_c_col">
                    <div class="width100 flex_c_between">
                        <span class="paper_line_left flex_c_left">姓名：{{ patientInfo.name }}</span>
                        <span
                            class="paper_line_left flex_c">性别：{{
                                patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'
                            }}</span>
                        <span
                            class="paper_line_left flex_c_right">年龄：{{
                                patientInfo.age === null ? '--' : patientInfo.age
                            }}岁</span>
                    </div>
                    <div class="width100 flex_c_between">
                        <div class="paper_line_left flex_c_left">
                            <span>处方号：{{ printMedicalOrder.serialNo }}</span>
                        </div>
                        <div class="paper_line_left flex_c_right">
                            <span>日期：{{ printMedicalOrder.createTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="paper_line flex_left_warp">
                    <span>临床诊断：{{
                            printMedicalOrder.clinicalDiagnosis === null ? '无' : printMedicalOrder.clinicalDiagnosis
                        }}</span>
                </div>
                <div class="paper_line flex_t_col">
                    <div class="detail_info_line flex_c_between">
                        <div class="width100" style="font-size: 18px;font-weight: bold">RP：
                            <span class="font_gold">{{
                                    printMedicalOrder.billingType === '1' ? '饮片' : printMedicalOrder.billingType === '2' ? '膏方' : printMedicalOrder.billingType === '3' ? '水丸' : '颗粒'
                                }}</span>
                        </div>
                    </div>
                    <div class="detail_info_line detail_con">
                        <div class="med_list_con flex_left_warp">
                            <div class="med_list_li" v-for="(item, index) in printMedicalOrder.orderMedicineList"
                                 :key="index">
                                <span class="med_li_name12">{{ item.meName }}</span>
                                <span class="font_gold"
                                      v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                        item.drugProperty
                                    }})</span>
                                <span class="font_gray"
                                      v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{
                                        item.decoctionName
                                    }})</span>
                                <span class="mrl10">{{ item.newGCount }}<span class="mrl5">g</span></span>
                            </div>
                        </div>
                    </div>
                    <div class="detail_info_line flex_t_col"
                         v-if="printMedicalOrder.billingType === '2' && printMedicalOrder.orderMedicineFuList.length > 0">
                        <div class="detail_font flex_c_left">辅料：</div>
                        <div class="font_black">{{ showOrderMedicineFuList }}</div>
                    </div>
                    <div class="detail_info_line mrt10 flex_c_col">
                        <div class="mrt10 font_weight">{{ printMedicalOrder.instructions }}</div>
                        <div class="mrt10 font_weight">- - - - - 处方内容完毕 - - - - -</div>
                        <!--                        <div class="mrt10">每剂 {{ printMedicalOrder.orderMedicineList.length }} 味药材，共{{ printMedicalOrder.viceNum }} 剂</div>-->
                    </div>
                </div>
                <div class="paper_line paper_bottom_border flex_c_between">
                    <div class="paper_ercode">
                        <el-image class="qrCode"
                                  :src="tencentCosUrl+printMedicalOrder.payQrcode"
                                  :zoom-rate="1.2"
                                  :max-scale="7"
                                  :min-scale="0.2" :hide-on-click-modal="true"
                                  :preview-src-list="payCodeList"
                                  fit="fill"
                        />
                        <div class="qrCode_info">扫码线上支付</div>
                    </div>
                    <!--            <div class="paper_ercode_right">-->
                    <!--                <el-image class="qrCode" :src="tencentCosUrl+doctorInfo.qrCode" fit="fill"></el-image>-->
                    <!--                <div class="qrCode_info">扫码关联医师</div>-->
                    <!--            </div>-->
                    <div class="paper_line_two flex_t_col">
                        <div class="paper_line_ifo flex_c_left"><span
                            class="font_black">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
                        <!--                        <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总重：</span><span class="detail_font_gold">{{printMedicalOrder.orderWeight === null ? '0' : parseFloat(printMedicalOrder.orderWeight).toFixed(2)}}</span>g</div>-->
                        <div class="paper_line_ifo flex_c_left"><span class="font_black">每剂 {{
                                printMedicalOrder.orderMedicineList.length
                            }} 味药材，共{{ printMedicalOrder.viceNum }} 剂</span></div>
                        <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总费用：</span><span
                            class="detail_font_red">{{ printMedicalOrder.orderPrice }}</span>元
                        </div>
                    </div>
                </div>
                <div class="paper_line flex_bot_between">
                    <div class="paper_line_left_left flex_c_left" style="height: 42px">
                        <div class="paper_left">核对/发药：</div>
                        <div class="paper_right">
                            <span>{{
                                    printMedicalOrder.billingType === '0' ? '知夏中医颗粒药房' : '知夏中医饮片药房'
                                }}</span>
                        </div>
                    </div>
                    <div class="paper_line_left flex_c_right">
                        <div class="paper_left">核发医师：</div>
                        <div class="paper_right">
                            <el-image style="height: 42px" :src="tencentCosUrl+doctorInfo.signPic"
                                      fit="cover"></el-image>
                        </div>
                    </div>
                </div>
                <div class="paper_line_bot flex_c_between">
                    <div class="paper_line_left flex_left_bottom">
                    </div>
                    <div class="paper_line_left flex_c_right">
                        <span>打印日期：{{ printDate }}</span>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="dialog-footer no-print">
                    <el-button @click="cancelOrderPrint()">取消</el-button>
                    <el-button type="primary" v-print="printInfoObj">打印</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 患者病历-->
        <el-dialog v-model="patientDialogVisible" width="600px" center :close-on-click-modal="false">
            <div class="bingli_Dialog" id="printBingliArea">
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="isLoadingPatient">
                    <el-icon class="pay_loading_icon is-loading">
                        <loading/>
                    </el-icon>
                    <div class="pay_loading_text">正在查询，请稍候...</div>
                </div>
                <div class="bingli_title_con">
                    <div class="bingli_title">知夏中医门诊部</div>
                    <div class="bingli_title">门诊病历</div>
                </div>
                <div class="bingli_line flex_c_col">
                    <div class="width100">
                        <span class="mrr20"><span
                            class="font_weight">就诊时间：</span>{{ bingliMedicalOrder.createTime }}</span>
                        <span class="mrr20"><span class="font_weight">就诊科室：</span>知夏中医门诊</span>
                        <span class="mrr20"><span
                            class="font_weight">就诊类型：</span>{{
                                bingliMedicalOrder.isFirstVisit === '0' ? '初诊' : '复诊'
                            }}</span>
                    </div>
                    <div class="width100">
                        <span class="mrr20"><span
                            class="font_weight">就诊处方号：</span>{{ bingliMedicalOrder.serialNo }}</span>
                    </div>
                </div>
                <div class="bingli_line flex_left_warp">
                    <div class="width100 flex_c_left">
                        <span class="flex_c_left mrr20"><span
                            class="font_weight">姓名：</span>{{ bingliInfo.name }}</span>
                        <span class="flex_c_left mrr20"><span
                            class="font_weight">性别：</span>{{
                                bingliInfo.sex === '0' ? '男' : bingliInfo.sex === '1' ? '女' : '未知'
                            }}</span>
                        <span class="flex_c_left mrr20"><span
                            class="font_weight">年龄：</span>{{
                                bingliInfo.age === null ? '--' : bingliInfo.age
                            }}岁</span>
                        <span class="flex_c_left mrr20"><span
                            class="font_weight">手机号码：</span>{{
                                bingliInfo.phoneNumber === null ? '--' : bingliInfo.phoneNumber
                            }}</span>
                    </div>
                    <div class="width100 flex_c_left">
                        <div class="flex_c_left mrr20">
                            <span><span
                                class="font_weight">身份证号：</span>{{
                                    bingliInfo.identity === null ? '--' : bingliInfo.identity
                                }}</span>
                        </div>
                        <div class="flex_c_left mrr20">
                            <span v-if="bingliInfo.province === null"><span
                                class="font_weight">家庭住址：</span>暂无</span>
                            <span v-if="bingliInfo.province !== null"><span
                                class="font_weight">家庭住址：</span>{{ bingliInfo.province }}</span>
                        </div>
                    </div>
                    <div class="width100"><span
                        class="font_weight">主诉：</span>{{
                            bingliMedicalOrder.mainSuit === null || bingliMedicalOrder.mainSuit === '' ? '暂无' : bingliMedicalOrder.mainSuit
                        }}
                    </div>
                    <div class="width100"><span
                        class="font_weight">现病史：</span>{{
                            bingliMedicalOrder.nowMedicalHistory === null || bingliMedicalOrder.nowMedicalHistory === '' ? '暂无' : bingliMedicalOrder.nowMedicalHistory
                        }}
                    </div>
                    <div class="width100"><span
                        class="font_weight">既往史：</span>{{
                            bingliMedicalOrder.patientMedicalHistory === null || bingliMedicalOrder.patientMedicalHistory === '' ? '暂无' : bingliMedicalOrder.patientMedicalHistory
                        }}
                    </div>
                    <div class="width100"><span
                        class="font_weight">过敏史：</span>{{
                            bingliMedicalOrder.patientOperationHistory === null || bingliMedicalOrder.patientOperationHistory === '' || bingliMedicalOrder.patientOperationHistory === undefined ? '暂无' : bingliMedicalOrder.patientOperationHistory
                        }}
                    </div>
                    <div class="width100"><span
                        class="font_weight">临床诊断：</span>{{
                            bingliMedicalOrder.clinicalDiagnosis === null || bingliMedicalOrder.clinicalDiagnosis === '' ? '暂无' : bingliMedicalOrder.clinicalDiagnosis
                        }}
                    </div>
                    <div class="width100"><span
                        class="font_weight">检查记录：</span>{{
                            bingliMedicalOrder.inspectionRecord === null || bingliMedicalOrder.inspectionRecord === '' ? '暂无' : bingliMedicalOrder.inspectionRecord
                        }}
                    </div>
                    <div class="width100"><span class="font_weight">处理意见：</span>中药治疗</div>
                </div>
                <div class="bingli_line flex_bot_between">
                    <div class="paper_line_left_left flex_c_left">
                    </div>
                    <div class="paper_line_left flex_c_right">
                        <div class="paper_left">门诊医生：</div>
                        <div class="paper_right">
                            <el-image style="height: 42px" :src="tencentCosUrl+doctorInfo.signPic"
                                      fit="cover"></el-image>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="dialog-footer no-print">
                    <el-button @click="cancelOpenBingliInfo()">取消</el-button>
                    <el-button type="primary" v-print="printBingliInfoObj">打印</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 订单收费 -->
        <el-dialog
            v-model="orderPayDialogVisible"
            :before-close="cancalPay"
            :show-close="!payDialogLocked"
            :close-on-click-modal="!payDialogLocked"
            :close-on-press-escape="!payDialogLocked"
            title="订单收费"
            width="32%"
            align-center
        >
            <div class="pay_content flex_c_col">
                <div class="pay_main_body flex_t_col">
                    <!--等待扫码-->
                    <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed">
                        <el-icon class="pay_screen_icon">
                            <Connection/>
                        </el-icon>
                        <div class="pay_screen_text">正在等待扫码中，请稍候...</div>
                    </div>
                    <!--加载圈-->
                    <div class="pay_loading_con flex_c_col" v-if="isWaitPayLoading && payLoading && !isPayed">
                        <el-icon class="pay_loading_icon is-loading">
                            <loading/>
                        </el-icon>
                        <div class="pay_loading_text">正在等待订单支付，请稍候...</div>
                        <div class="pay_loading_text" v-if="payDialogLocked">查询支付结果中，请勿关闭弹窗</div>
                    </div>

                    <!-- 订单信息-->
                    <div class="pay_order_main" v-if="isWaitPayLoading && !isPayed">
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">患者信息：</div>
                            <div class="pay_info_item_right">{{ patientInfo.name }}
                                {{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}
                                {{ patientInfo.age === null ? '--' : patientInfo.age }}岁
                            </div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">身份证号：</div>
                            <div class="pay_info_item_right">
                                {{
                                    patientInfo.identity === null ? "--" : patientInfo.identity.substr(0, 6) + '********' + patientInfo.identity.substr(14, 20)
                                }}
                            </div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">药方单号：</div>
                            <div class="pay_info_item_right">{{ printMedicalOrder.serialNo }}</div>
                        </div>
                        <div class="pay_info_title">支付信息</div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">优惠金额：</div>
                            <div class="pay_info_item_right">
                                ￥{{
                                    printMedicalOrder.discountPrice === null ? "0.00" : printMedicalOrder.discountPrice
                                }}
                            </div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">加工费用：</div>
                            <div class="pay_info_item_right">
                                ￥{{
                                    printMedicalOrder.processingCosts === null || printMedicalOrder.processingCosts === undefined ? '0.00' : printMedicalOrder.processingCosts
                                }}
                            </div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">订单实付：</div>
                            <div class="pay_info_item_right font_weight font_orange font_28">
                                ￥{{ printMedicalOrder.orderPrice }}
                            </div>
                        </div>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li">*特殊说明：</div>
                            <div class="pay_warning_li">①请仔细核对患者和订单信息，避免错误收费。</div>
                            <div class="pay_warning_li">
                                ②请患者打开移动付款码放置扫码盒子上或使用扫码枪扫患者的付款二维码，完成支付。
                            </div>
                        </div>
                    </div>
                    <!-- 订单结果-->
                    <div class="pay_order_main" v-if="!isWaitPayLoading && isPayed">
                        <div class="pay_order_success flex_c_col">
                            <el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'">
                                <SuccessFilled/>
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'">
                                <WarningFilled/>
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'">
                                <CircleCloseFilled/>
                            </el-icon>
                            <div class="pay_order_success_text flex_c font_16"><span class="font_gold mrlr10 font_18">{{
                                    patientInfo.name
                                }}</span>的药方订单{{ payResultText }}
                            </div>
                            <div class="pay_order_error_text flex_c font_14" v-if="payState !== 'success' && payErrorMsg"
                                 :style="{color: payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ payErrorMsg }}</div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">药方单号：</div>
                                <div class="pay_info_item_right font_weight">{{ printMedicalOrder.serialNo }}</div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">支付单号：</div>
                                <div class="pay_info_item_right font_weight">{{ printMedicalOrder.serialNo }}</div>
                            </div>
                            <div class="pay_info_item flex_c_between" v-if="successPayed">
                                <div class="pay_info_item_left">支付时间：</div>
                                <div class="pay_info_item_right font_weight">{{ printMedicalOrder.payTime }}</div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">优惠金额：</div>
                                <div class="pay_info_item_right">
                                    ￥{{
                                        printMedicalOrder.discountPrice === null ? "0.00" : printMedicalOrder.discountPrice
                                    }}
                                </div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">加工费用：</div>
                                <div class="pay_info_item_right">
                                    ￥{{
                                        printMedicalOrder.processingCosts === null || printMedicalOrder.processingCosts === undefined ? '0.00' : printMedicalOrder.processingCosts
                                    }}
                                </div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">订单实付：</div>
                                <div class="pay_info_item_right font_weight font_orange font_28">
                                    ￥{{ printMedicalOrder.orderPrice }}
                                </div>
                            </div>
                            <div class="pay_warning_info flex_t_col">
                                <div class="pay_warning_li">*特殊说明：</div>
                                <div class="pay_warning_li" v-if="payDialogLocked">查询支付结果中，请勿关闭弹窗。</div>
                                <div class="pay_warning_li">①若订单支付失败，请重新扫患者的付款二维码进行扫码支付。</div>
                                <div class="pay_warning_li">
                                    ②支付完成后，请告知患者可打开“知夏中医健康平台”小程序，查询订单支付结果。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询
                    </el-button>
                    <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试
                    </el-button>
                    <!--                    <el-button type="success" v-if="isPayed && successPayed" onclick="printPayed()">打印小票</el-button>-->
                    <!--                    <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                    <el-button type="info" @click="cancalPay()">取消</el-button>
                </div>
            </template>
        </el-dialog>

    </div>

</template>

<script>
import clinictreat from "@/assets/scripts/clinictreat/index";

export default clinictreat;
</script>

<style scoped>
@import "@/assets/styles/style.scss";

.prescription_count_tag {
    margin-left: 10px;
    border: 0;
    border-radius: 10px;
    background: #eaf3ff;
    color: #2f80c9;
    vertical-align: middle;
}

.prescription_section_heading {
    align-items: baseline;
    gap: 12px;
}

.prescription_section_hint {
    overflow: hidden;
    color: #9aa4b2;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_workspace {
    margin: 0 0 14px;
    padding: 12px 14px 14px;
    border: 1px solid #e6ebf2;
    border-radius: 8px;
    background: #fbfcfe;
    box-shadow: 0 2px 8px rgba(34, 55, 78, .04);
}

.prescription_workspace_header,
.prescription_workspace_title,
.prescription_workspace_actions {
    display: flex;
    align-items: center;
}

.prescription_workspace_header {
    justify-content: space-between;
    gap: 16px;
}

.prescription_workspace_title {
    min-width: 0;
    gap: 10px;
}

.prescription_workspace_kicker {
    color: #2f80c9;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .5px;
}

.prescription_workspace_current {
    padding-left: 10px;
    border-left: 1px solid #dfe6ef;
    color: #303b49;
    font-size: 14px;
    font-weight: 600;
}

.prescription_workspace_subtitle {
    margin: 6px 0 10px;
    color: #9aa4b2;
    font-size: 12px;
}

.prescription_workspace_actions {
    flex: 0 0 auto;
    gap: 8px;
}

.prescription_workspace_actions :deep(.el-button) {
    margin-left: 0;
    border-radius: 4px;
}

.prescription_draft_tabs {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 8px;
}

.prescription_draft_tab {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 0;
    min-height: 58px;
    padding: 9px 10px 9px 12px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #fff;
    color: #5e6b7a;
    cursor: pointer;
    text-align: left;
    transition: border-color .2s, background .2s, box-shadow .2s, transform .2s;
}

.prescription_draft_tab::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    background: transparent;
    content: '';
}

.prescription_draft_tab:hover {
    border-color: #b9d8f5;
    box-shadow: 0 3px 10px rgba(64, 158, 255, .08);
    transform: translateY(-1px);
}

.prescription_draft_tab.active {
    border-color: #8fc4ef;
    background: #f3f8fd;
    box-shadow: 0 3px 10px rgba(64, 158, 255, .12);
    color: #2f80c9;
}

.prescription_draft_tab.active::before {
    background: #409eff;
}

.prescription_draft_index {
    flex: 0 0 28px;
    color: #b6c0cc;
    font-size: 12px;
    font-weight: 600;
}

.prescription_draft_main {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    gap: 3px;
}

.prescription_draft_main strong {
    overflow: hidden;
    color: #394654;
    font-size: 13px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_draft_tab.active .prescription_draft_main strong {
    color: #2476b5;
}

.prescription_draft_main small {
    overflow: hidden;
    color: #9aa4b2;
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_draft_price {
    flex: 0 0 auto;
    margin-left: 8px;
    color: #d9822b;
    font-size: 12px;
    font-weight: 600;
}

@media (max-width: 900px) {
    .prescription_workspace_header {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }

    .prescription_workspace_actions {
        width: 100%;
    }

    .prescription_workspace_actions :deep(.el-button) {
        flex: 1;
    }
}

@media (max-width: 560px) {
    .prescription_section_heading {
        align-items: flex-start;
        flex-direction: column;
        gap: 4px;
    }

    .prescription_draft_tabs {
        grid-template-columns: 1fr;
    }
}

.clinical_section_basic,
.clinical_section_diagnosis,
.clinical_section_prescriptions {
    border: 1px solid #e4eaf1;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(35, 61, 86, .035);
}

.clinical_section_basic,
.clinical_section_diagnosis {
    margin-bottom: 12px;
}

.clinical_section_basic .title_in_body,
.clinical_section_diagnosis .title_in_body {
    min-height: 46px;
    padding: 0 16px;
    border-bottom: 1px solid #e8edf3;
}

.clinical_section_basic .title_span,
.clinical_section_diagnosis .title_span {
    color: #273b50;
    font-size: 15px;
    font-weight: 600;
}

.clinical_section_prescriptions {
    overflow: visible;
}

.prescription_sticky_head {
    position: sticky;
    z-index: 20;
    top: 0;
    background: #f8fafc;
    box-shadow: 0 4px 10px rgba(35, 61, 86, .08);
}

.prescription_sticky_head .prescription_section_header {
    border-radius: 8px 8px 0 0;
}

.prescription_sticky_head .prescription_tabs_bar {
    border-bottom-color: #dfe7ef;
}

.prescription_section_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 52px;
    padding: 0 16px;
    border-bottom: 1px solid #e5ebf2;
}

.prescription_section_title {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 10px;
}

.prescription_section_title .title_line {
    flex: 0 0 auto;
}

.prescription_section_title .title_span {
    font-size: 15px;
    color: #273b50;
}

.prescription_section_hint {
    overflow: hidden;
    color: #9aa4b2;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_workspace_actions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 8px;
}

.prescription_workspace_actions :deep(.el-button) {
    margin-left: 0;
    border-radius: 4px;
}

.prescription_tabs_bar {
    padding: 12px 16px 0;
    border-bottom: 1px solid #dfe7ef;
    background: #f2f6fa;
}

.prescription_tabs_scroll {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
}

.prescription_tab_item {
    position: relative;
    display: flex;
    flex: 0 0 178px;
    align-items: center;
    min-width: 0;
    min-height: 58px;
    margin-bottom: -1px;
    padding: 9px 12px 10px 13px;
    border: 1px solid #d8e1eb;
    border-bottom-color: #ccd7e2;
    border-radius: 6px 6px 0 0;
    background: #e8eef4;
    color: #647589;
    cursor: pointer;
    text-align: left;
    transition: background .2s, border-color .2s, color .2s, box-shadow .2s;
}

.prescription_tab_item:hover {
    border-color: #9fc7eb;
    background: #f5f9fd;
    color: #2f78b4;
}

.prescription_tab_item.active {
    z-index: 1;
    border-color: #9fc7eb;
    border-bottom-color: #fff;
    background: #fff;
    box-shadow: 0 -3px 10px rgba(54, 93, 126, .08);
    color: #216da8;
}

.prescription_tab_item.disabled {
    cursor: not-allowed;
    opacity: .72;
    pointer-events: none;
}

.prescription_tab_item.disabled.active {
    opacity: 1;
}

.prescription_tab_item.active::before {
    position: absolute;
    top: -1px;
    right: 10px;
    left: 10px;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background: #3288cf;
    content: '';
}

.prescription_tab_number {
    flex: 0 0 27px;
    color: #aab6c3;
    font-size: 12px;
    font-weight: 600;
}

.prescription_tab_item.active .prescription_tab_number {
    color: #409eff;
}

.prescription_tab_content {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    gap: 4px;
}

.prescription_tab_content strong,
.prescription_tab_content small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.prescription_tab_content strong {
    color: #304456;
    font-size: 13px;
    font-weight: 600;
}

.prescription_tab_item.active .prescription_tab_content strong {
    color: #216da8;
}

.prescription_tab_content small {
    color: #8493a3;
    font-size: 11px;
}

.prescription_tab_price {
    flex: 0 0 auto;
    margin-left: 6px;
    color: #c77724;
    font-size: 12px;
    font-weight: 600;
}

.prescription_active_label {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 0 18px;
    border-bottom: 1px solid #e5ebf2;
    color: #8493a3;
    font-size: 12px;
}

.prescription_active_label strong {
    color: #344454;
    font-size: 13px;
}

.prescription_active_line {
    height: 1px;
    flex: 1;
    background: #edf0f4;
}

.prescription_tab_panel {
    margin: 14px 16px 18px;
    border: 1px solid #e4eaf1;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
}

.prescription_tab_panel > .med_body {
    margin: 10px auto;
}

.prescription_tab_panel > .right_floor {
    margin: 0;
    border-top: 1px solid #e6ecf2;
}

.prescription_tab_panel > .right_floor:first-of-type {
    border-top: 0;
}

.prescription_tab_panel > .right_floor .title_in_body {
    min-height: 44px;
    padding: 0 16px;
    border-bottom: 1px solid #edf1f5;
    background: #fafbfd;
}

.prescription_tab_panel > .right_floor .med_body_2 {
    padding: 16px;
}

.prescription_tab_panel > .right_floor .title_span {
    color: #3f4d5c;
    font-size: 14px;
}

.prescription_tab_panel > .right_floor .alert_info_span {
    margin-left: 10px;
}

@media (max-width: 560px) {
    .prescription_tab_panel {
        margin: 10px 8px 14px;
    }
}

@media (max-width: 900px) {
    .prescription_section_header {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .prescription_section_title {
        width: 100%;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .prescription_workspace_actions {
        width: 100%;
    }

    .prescription_workspace_actions :deep(.el-button) {
        flex: 1;
    }
}

@media (max-width: 560px) {
    .prescription_section_hint {
        flex-basis: 100%;
        padding-left: 18px;
    }

    .prescription_tab_item {
        flex-basis: 165px;
    }
}
</style>
